import axios from './index'
import store from '@/store'
import { cleanParams } from '@/filters'
export const getTagLabel = () => {
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/tag', {
    params: cleanParams({
      pageNum: 1,
      pageSize: 10000,
      companyId,
      teamId
    })
  })
}

export const getTagLabelByPage = (params) => {
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/tag', {
    params: cleanParams({ ...params, companyId, teamId })
  })
}

export const addTagLabel = (params) => {
  const user = store.state.userInfo
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.post('/welldbCombine/tag', {
    moveToQuery: true,
    params: cleanParams({ ...params, companyId, teamId, createUserId: user.userId })
  })
}

export const updateTagLabel = (params) => {
  return axios.put('/welldbCombine/tag', {
    moveToQuery: true,
    params
  })
}

export const deleteTagLabel = (id) => {
  return axios.delete('/welldbCombine/tag', {
    params: {
      id
    }
  })
}
